<template>
  <section class="page-section">
    <div class="page-section__content">
      <div class="uneven-columns__second--width" data-overlay-prevent-close>
        <collapsibleBlock
          v-if="hasIdentifiedWorks"
          ariaLabel="how we identified these works"
          blockName="installation-image-how-we-identified"
          title="How we identified these works"
          >
          <p v-html="i18n.t('collection__installation-images__how-we-identified__content')"></p>
          <p v-html="i18n.t('collection__installation-images__how-we-identified__error')"></p>
        </collapsibleBlock>

        <collapsibleBlock
          ariaLabel="licensing"
          blockName="installation-image-licensing"
          title="Licensing"
          >
          <p v-html="i18n.t('collection__installation-images__licensing__content')"></p>
        </collapsibleBlock>
        <collapsibleBlock
          ariaLabel="feedback"
          blockName="installation-image-feedback"
          title="Feedback"
          >
          <p v-html="i18n.t('collection__installation-images__feedback__content')"></p>
        </collapsibleBlock>
      </div>
    </div>
  </section>
</template>

<script>
  import collapsibleBlock from './collapsible-block.vue';
  import i18n from '../../../utils/i18n.js';

  export default {
    data: function(){
      return {
        i18n: new i18n(),
      }
    },

    props: {
       hasIdentifiedWorks: {type: Boolean, required: true },
    },

    components: {
      collapsibleBlock,
    }
  }

</script>

